import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { ReportService } from '../services/report.service';
import { CategoryService } from '../services/category.service';
import { ProductService } from '../services/product.service';
import { finalize } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { UnitService } from '../../core/services/unit-service';

@Component({
  selector: 'app-report-by-date',
  templateUrl: './report-by-date.component.html',
  styleUrls: ['./report-by-date.component.css'],
})
export class ReportByDateComponent
  extends SecondPageIndexBase
  implements OnInit
{
  unitCode: any = this.currentUser.unitCode;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  listUnit: { label: string; value: string }[] = [];
  listCategory: { label: string; value: string }[] = [];
  listProduct: { label: string; value: string }[] = [];
  categoryId: any;
  productId: any;
  fromDate: any;
  toDate: any;
  month: any;
  isDate: any = true;
  isMonth: any = false;
  sumInfo = {
    saleRecordsQuantity: 0,
    salesNumber: 0,
    revenue: 0,
    totalRemuneration: 0,
    remunerationReceived: 0,
  };

  constructor(
    private _service: ReportService,
    protected _categoryService: CategoryService,
    protected _productService: ProductService,
    protected _unitService: UnitService,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      unitCode: new UntypedFormControl(''),
      categoryId: new UntypedFormControl(''),
      productId: new UntypedFormControl(''),
      fromDate: new UntypedFormControl(''),
      toDate: new UntypedFormControl(''),
      month: new UntypedFormControl(''),
      isMonth: new UntypedFormControl(''),
      isDate: new UntypedFormControl(''),
    });
    this.cols = [
      // {
      //   field: 'stt',
      //   header: 'STT',
      //   visible: true,
      //   sort: false,
      //   width: 3,
      // },
      {
        field: 'salesDate',
        header: 'Ngày bán',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'saleRecordsQuantity',
        header: 'Sản lượng',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'salesNumber',
        header: 'Doanh số bán',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'revenue',
        header: 'Doanh thu',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'totalRemuneration',
        header: 'Tổng thù lao',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'remunerationReceived',
        header: 'Thù lao được nhận',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
    let date = new Date();
    this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.toDate = new Date();
    this.month = new Date();
  }
  ngOnInit(): void {
    this.getListService();
    this.getListUnit();
    // this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getListProduct() {
    if (this.categoryId !== null && this.categoryId !== undefined) {
      this.listProduct = [];
      this.productId = 0;
      const model = {
        categoryId: this.categoryId,
        status: 1
      };
        this._productService.getListProduct(model).then(res => {
          this.listProduct = res?.data?.map(x => ({label: `${x.code} - ${x.name}`, value: x.id}));
          this.listProduct.unshift({label: 'Chọn tất cả', value: ''});
        },err => {
          this.listProduct = [];
          this.listProduct.unshift({label: 'Chọn tất cả', value: ''});
        })
    }
  }

  getListService() {
    const model = {
      status: 1
    };
    this.listCategory = [];
    this._categoryService.getListCategory(model).then(res => {
      this.listCategory = res?.data?.map(x => ({label: `${x.code} - ${x.name}`, value: x.id}));
      this.listCategory.unshift({label: 'Chọn tất cả', value: ''});
      },err => {
      this.listCategory = [];
      this.listCategory.unshift({label: 'Chọn tất cả', value: ''});
    })
  }

  getListUnit() {
    this._unitService.getTreeUnitByUnitCode(this.unitCode)
      .then(response => {
        this.listUnit = response.data.map(r => ({label: `- ${r.unitName} (${r.unitCode})`, value: r.unitCode}));
    }, error => {
        this.listUnit = [];
      });
  }

  getData() {
    this.isLoading = true;
    var model = {
      reportType: 'DATE',
      unitCode : !this.unitCode ? null : this.unitCode,
      categoryId : !this.categoryId ? null : this.categoryId,
      month : this.isMonth ? `${this.month.getFullYear()}-${(this.month.getMonth() + 1).toString().padStart(2, '0')}-${this.month.getDate().toString().padStart(2, '0')}` : null,
      startDate : this.isDate ? `${this.fromDate.getFullYear()}-${(this.fromDate.getMonth() + 1).toString().padStart(2, '0')}-${this.fromDate.getDate().toString().padStart(2, '0')}` : null,
      endDate : this.isDate ? `${this.toDate.getFullYear()}-${(this.toDate.getMonth() + 1).toString().padStart(2, '0')}-${this.toDate.getDate().toString().padStart(2, '0')}` : null,
      productId : !this.productId ? null : this.productId,
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };
    this._service
      .getDataReport(model)
      .then((rs) => {
          this.dataSource = rs?.data;
          this.totalRecord = rs?.total;
      }, err => {
        this.dataSource = [];
        this.totalRecord = 0;
      })
      .finally(() => (this.isLoading = false));
    this._service.sumByParams(model).then((rs) => {
      this.sumInfo = rs.data;
      }, err => {
        this.sumInfo = {
          saleRecordsQuantity: 0,
          salesNumber: 0,
          revenue: 0,
          totalRemuneration: 0,
          remunerationReceived: 0,
        }
      });
  }

  exportExcel() {
    this.isLoading = true;
    var model = {
      reportType: 'DATE',
      unitCode : this.unitCode,
      categoryId : !this.categoryId ? null : this.categoryId,
      month : this.isMonth ? `${this.month.getFullYear()}-${(this.month.getMonth() + 1).toString().padStart(2, '0')}-${this.month.getDate().toString().padStart(2, '0')}` : null,
      startDate : this.isDate ? `${this.fromDate.getFullYear()}-${(this.fromDate.getMonth() + 1).toString().padStart(2, '0')}-${this.fromDate.getDate().toString().padStart(2, '0')}` : null,
      endDate : this.isDate ? `${this.toDate.getFullYear()}-${(this.toDate.getMonth() + 1).toString().padStart(2, '0')}-${this.toDate.getDate().toString().padStart(2, '0')}` : null,
      productId : !this.productId ? null : this.productId,
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };
    const date = new Date();
    const dateStr = `${date.getDate().toString().padStart(2, '0')}_${(date.getMonth() + 1).toString().padStart(2, '0')}_${date.getFullYear()}`;

    this._service
      .exportExcel(model)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((blob) => {
        saveAs(blob, `report_by_date_${dateStr}.xlsx`);
      });
  }

  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
  selectDate() {
    if (this.isDate == true) {
      this.isMonth = false;
    }
    if (this.isDate == false) {
      this.isMonth = true;
    }
  }
  selectMonth() {
    if (this.isMonth == true) {
      this.isDate = false;
    }
    if (this.isMonth == false) {
      this.isDate = true;
    }
  }
}
